/**
 * Display helpers for service time/distance — uses DB values first, then derived fallbacks.
 */

const parseMeta = (service) => {
  const md = service?.meta_data;
  if (!md) return null;
  if (typeof md === 'object') return md;
  try {
    return JSON.parse(md);
  } catch {
    return null;
  }
};

export const minutesFromTimestamps = (startedAt, completedAt) => {
  if (!startedAt || !completedAt) return null;
  const start = new Date(startedAt);
  const end = new Date(completedAt);
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return null;
  const mins = Math.round((end - start) / (1000 * 60));
  return mins > 0 ? mins : null;
};

export const resolveEstimatedTimeMinutes = (service) => {
  const stored = service?.estimated_time_minutes;
  if (stored != null && stored !== '' && Number(stored) > 0) {
    return Number(stored);
  }
  const meta = parseMeta(service);
  const routeMins = meta?.route_calculation?.total_duration_minutes;
  if (routeMins != null && Number(routeMins) > 0) {
    return Math.round(Number(routeMins));
  }
  return null;
};

export const resolveActualTimeMinutes = (service) => {
  const stored = service?.actual_time_minutes;
  if (stored != null && stored !== '' && Number(stored) > 0) {
    return Number(stored);
  }
  return minutesFromTimestamps(service?.started_at, service?.completed_at);
};

export const resolveDistanceKm = (service) => {
  const stored = service?.distance_km;
  if (stored != null && stored !== '' && !Number.isNaN(Number(stored)) && Number(stored) > 0) {
    return Number(stored);
  }
  const meta = parseMeta(service);
  const routeKm = meta?.route_calculation?.total_distance_km;
  if (routeKm != null && Number(routeKm) > 0) {
    return Number(routeKm);
  }
  return null;
};

export const formatTimeMinutes = (minutes) => {
  if (minutes == null || minutes === '' || Number(minutes) <= 0) return 'N/A';
  return `${minutes} mins`;
};

export const formatDistanceKm = (km) => {
  if (km == null || km === '' || Number.isNaN(Number(km)) || Number(km) <= 0) return 'N/A';
  return `${Number(km)} km`;
};

export const displayEstimatedTime = (service) =>
  formatTimeMinutes(resolveEstimatedTimeMinutes(service));

export const displayActualTime = (service) =>
  formatTimeMinutes(resolveActualTimeMinutes(service));

export const displayDistance = (service) => formatDistanceKm(resolveDistanceKm(service));
